mutation updateEmail($id: String!, $data: EmailInput!) {
    updateEmail(id: $id, data: $data) {
        id
        email
        subscription
        is_registered
        timestamp
    }
}
